import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const AOD_CLAUSES = [
  'REPAYMENT: The full amount is deducted in one payment from my next salary/payslip after approval. I consent to this deduction in terms of section 34 of the Basic Conditions of Employment Act 75 of 1997.',
  'INTEREST: No interest is charged on this loan.',
  'TERMINATION: If my employment ends before the debt is repaid, the outstanding balance may be deducted from my final pay, leave pay and any amount owed to me; any remaining balance is immediately due.',
  'DEFAULT: If any amount is not recovered when due, the full balance becomes immediately payable and I am liable for legal costs on the attorney-and-client scale, including collection commission.',
  "JURISDICTION: I consent to the jurisdiction of the Magistrate's Court.",
  "CERTIFICATE: A certificate signed by the Creditor's manager is prima facie proof of the amount owed.",
  'I have read and understood this acknowledgement, sign it freely and voluntarily, and my electronic signature is binding (ECT Act 25 of 2002).',
];

export const printAod = async (loanId) => {
  const win = window.open('', '_blank');
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const r = await axios.get(`${API_URL}/api/staff-loans/${loanId}/aod-pdf`, { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    if (win) win.location.href = url;
    else { const a = document.createElement('a'); a.href = url; a.download = `AOD_${loanId.slice(0, 8)}.pdf`; a.click(); }
  } catch {
    win?.close();
    toast.error('Could not open the AOD');
  }
};
